module.exports = __webpack_public_path__ + "static/img/freezer_shop.563c4bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/freezer_shop.jpg
// module id = xDjf
// module chunks = 1